
import Icon from 'vux/src/components/icon/index.vue'

export default {
name: "topTips",
components: { Icon },
methods: {
gotoTutorial:function(){
this.$router.push('/tutorial')
}
}
};



// WEBPACK FOOTER //
// ./src/items/topTips.vue